import { useEffect, useState } from 'react';
import { useAuthentication } from '../authentication/authProvider';

export const OutlookApp = () => {
  const { accessToken } = useAuthentication();

  const [subject, setSubject] = useState<string | undefined>(
    Office?.context?.mailbox.item?.subject,
  );

  useEffect(() => {
    Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, itemChanged);
  }, []);

  function itemChanged() {
    setSubject(Office?.context?.mailbox.item?.subject);
  }

  return (
    <div data-testid="outlook-app">
      {Office.context.mailbox.item?.itemType}
      {subject} {accessToken}
    </div>
  );
};
